import { isDefined } from './is-defined';

export function compact<T>(value: T[] | null): T[] {
    if (!isDefined(value)) return [];
    return value.filter((x) => !!x);
}
